<template>
  <div id="wishlist" class="page">
    <h1>Wunschliste</h1>    
    <div id="foto_container">
      <div id="foto">
        <img src="../assets/img/ben-2018.jpeg">
      </div>
      <div id="kidsname">
          <p>{{party.kidsname}}</p>
      </div>
    </div>
    <div id="wishlistbox">
      <ul>
        <li v-for="(wish,key) in party.wishes">
          <div :class=" 'wish ' + ( wish.taken !== false ? 'taken':'' ) ">
            <div class="wish_image">
              <img v-if=" wish.image != ''" :src="wish.image">
            </div>
            <div class="wish_content">
                <p><strong>{{ wish.name }}</strong><br>
                    EUR {{ wish.price}} &nbsp;<a :href="wish.url" target="_blank"><img class="shoplogo" src="../assets/img/onlineshops/amazon.de-logo.svg"></a>
                </p>
                <div class="actions">
                    <a v-if=" wish.taken == $store.state.userfacts.kid || key == $store.state.userfacts.gift ">Euer Geschenk</a> &nbsp; 
                    <a v-on:click="chooseGift(key)" class="button" v-if=" key == $store.state.userfacts.gift ">ansehen / ändern</a>
                    <a v-on:click="chooseGift(key)" class="button" v-if="!$store.state.userfacts.gift && wish.taken === false ">auswählen</a>
                </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {db} from '../service/firebase';  
export default {
  name: 'Wishlist',
  components: {
    
  },
  firebase: {},
  data (){
    return {
      party: {
        wishes:[]
      },
    }
  },
  mounted() {
    //console.log( this.$store.state.currentParty )
  },
  created (){
   this.$bindAsObject('party', db.ref('parties/' + this.$store.state.currentParty), null, function() { /* console.log('Ready fired!') */ } );
  },
  methods: {
    chooseGift(key) {
      //console.log( this.$store.state );
      //var cookieee = JSON.stringify({ 'currentParty': this.$store.state.currentParty, 'kid': null, 'gift': key })
       

      this.$store.state.userfacts.gift = key;
      this.$cookie.set('party', JSON.stringify(this.$store.state.userfacts), 30); 

      
      if( this.$store.state.userfacts.kid ) {
          console.log('updating taken ' + key + " / " + this.$store.state.userfacts.kid);
          var updates = {};
          updates['/parties/' + this.$store.state.currentParty + '/wishes/' + key  +'/taken' ] = this.$store.state.userfacts.kid;
          var ref =  db.ref().update(updates)
          console.log(ref)
          this.$router.push('/wishlist/wish/selected' )
      } else {
        this.$router.push('/guests' )        
      }
    }
  }
  
}

</script>
<style>
  #wishlistbox ul { display: inline-block; margin: 0 auto; padding: 2.4333333em 0.9333333em; list-style: none; width: 100%; max-width: 28em; }
  #wishlistbox img { max-width: 5em; }
  #wishlistbox p { text-align: left; line-height: 1.4333333rem; padding: 0; margin: 0; }
  #wishlistbox ul li { display: block; border-top: 2px solid #fcac1f; padding: 1.43333333em 0; }
  .wish { display: flex;  width: 100%; border: 0 solid red; }
  .wish.taken p { opacity: 0.4; }
  .wish_image { flex: 1 1 130px; text-align: left; }
  .wish_content { flex: 1 1 100%; padding: 0 1.43333333em; }
  .wish .forMe { }
  .wish .actions { text-align: right; padding: 0.53333em 0; max-width: 100%; }
  .wish .actions .button { margin: 0; }
  .shoplogo { display: inline-block; margin-top: 0.32222em; height: 1em; }
</style>
